import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { DatepickerSharedComponent } from './datepicker.component';

@NgModule({
    declarations: [
        DatepickerSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        NgbDatepickerModule.forRoot()
    ],
    exports: [
        DatepickerSharedComponent
    ]
})

export class DatepickerSharedModule {}
